var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightPattern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 700,
    viewBox: "0 0 320 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.473 701.543C348.473 701.543 298.276 596.14 174.1 614.848C34.8642 635.837 -24.8935 514.122 9.52697 430.964C44.0669 347.805 171.829 353.623 175.773 195.519C179.717 33.9935 340.585 5.96664e-05 340.585 5.96664e-05",
    stroke: "#f59e0b",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.882 579.714C385.882 579.714 279.752 534.085 174.22 550.397C68.6886 566.824 56.259 493.019 68.6886 463.703C94.2648 402.788 231.229 391.039 240.073 292.709C246.766 218.79 201.887 118.201 322 65.5001",
    stroke: "#f59e0b",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.553 530.549C338.553 530.549 230.153 546.975 249.515 474.311C271.744 391.039 323.853 392.293 274.613 286.891C257.044 249.361 251.905 98.33 348.473 128.787",
    stroke: "#f59e0b",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.095 477.848C106.095 495.299 127.927 509.446 154.858 509.446C181.788 509.446 203.62 495.299 203.62 477.848C203.62 460.397 181.788 446.25 154.858 446.25C127.927 446.25 106.095 460.397 106.095 477.848Z",
    stroke: "#f59e0b",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 700,
    fill: "white",
    transform: "translate(0.000244141)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightPattern);
export default __webpack_public_path__ + "static/media/right-pattern.921e2cedd3ed7117d092da4e9e39cfb1.svg";
export { ForwardRef as ReactComponent };